// extracted by mini-css-extract-plugin
module.exports = {"welcomeTop":"oOfSXnQQ","welcomeContainer":"_1bzbtWmU","WelcomeMessage":"_16L8d4pg","welcomeHeader":"_1ebSCQBX","publishButton":"_35Sbl6E5"};
    if(module.hot) {
      // 1754515027495
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  